import { BaseError } from "@/domains/errors";
import { objectModule } from "@/modules/object";
import { api } from "@/modules/api";
import { logger } from "@/modules/logger";

interface OAuthConsentArgs {
  clientId: string;
  redirectUri: string;
  scope?: string;
  state?: string;
  codeChallenge?: string;
  codeChallengeMethod?: string;
}

export const approveOAuthConsent = async ({
  clientId,
  redirectUri,
  scope,
  state,
  codeChallenge,
  codeChallengeMethod,
}: OAuthConsentArgs) => {
  const body: {
    client_id: string;
    redirect_uri: string;
    response_type: "code";
    scope?: string;
    state?: string;
    code_challenge?: string;
    code_challenge_method?: string;
  } = {
    client_id: clientId,
    redirect_uri: redirectUri,
    response_type: "code",
  };
  if (scope !== undefined) {
    body.scope = scope;
  }
  if (state !== undefined) {
    body.state = state;
  }
  if (codeChallenge !== undefined) {
    body.code_challenge = codeChallenge;
  }
  if (codeChallengeMethod !== undefined) {
    body.code_challenge_method = codeChallengeMethod;
  }

  const response = await api.post("/v2/oauth2/consent/approve", {
    body,
  });

  if (response.error) {
    const err = new BaseError({
      message: "[oauthModule] [approveOAuthConsent] Failed.",
      info: { result: objectModule.safeAsJson(response) },
    });

    throw err;
  }

  return response.data;
};

export const denyOAuthConsent = async ({
  clientId,
  redirectUri,
  scope,
  state,
}: OAuthConsentArgs) => {
  const body: {
    client_id: string;
    redirect_uri: string;
    response_type: "code";
    scope?: string;
    state?: string;
  } = {
    client_id: clientId,
    redirect_uri: redirectUri,
    response_type: "code",
  };
  if (scope !== undefined) {
    body.scope = scope;
  }
  if (state !== undefined) {
    body.state = state;
  }

  const response = await api.post("/v2/oauth2/consent/deny", {
    body,
  });

  if (response.error) {
    const err = new BaseError({
      message: "[oauthModule] [denyOAuthConsent] Failed.",
      info: { result: objectModule.safeAsJson(response) },
    });

    logger.error({
      message: "[oauthModule] [denyOAuthConsent] Failed.",
      info: { error: err.message },
    });

    throw err;
  }

  return response.data;
};
